import watch from './view/watch';
import SearchView from './view/SearchView';
import filterResults from './filterResults';
import makeGetters from './makeGetters';
import selectors from '../../globals/selectors';
import constants from '../../globals/constants';
import apiEndpoints from "../../globals/apiEndpoints";
import axios from "axios";
import htmlToDom from '../../helpers/htmlToDom';
import StatesSaver from "./../statesSaver";

/**
 * Search component logic.
 * @param {string} selector
 * @param {{ input?: (string | null), list?: ({ text: string, link: string }[] | null) }} initialState
 * @returns {HTMLElement} Html element of component.
 */
export default (selector, initialState = {}) =>
{
	const state =
	{
		input: null,
		list: null,
		results: null,
		ui: {
			isListVisible: false,
		},
		...initialState,
	};

	const view = new SearchView(selector);
	const watchedState = watch(state, view);
	const getters = makeGetters(watchedState);

	const onInputHandle = (ev) =>
	{
		const { value } = ev.target;
		watchedState.input = value.trim();
		watchedState.results = filterResults(watchedState.input, watchedState.list);
		watchedState.ui.isListVisible = getters.hasResults;
	};

	const handleInputFocus = () =>
	{
		if (getters.hasResults)
			watchedState.ui.isListVisible = true;
	};

	const handleBodyClick = (ev) =>
	{
		const isClickedOutside = !ev.target.closest(selectors.search.input);
		if (isClickedOutside)
			watchedState.ui.isListVisible = false;
	};

	const handleBodyKeyUp = (ev) =>
	{
		const key = ev.code;
		const isPressedEscape = key === constants.keyCodes.escape;
		if (isPressedEscape)
			watchedState.ui.isListVisible = false;
	};

	const handleInputClick = () =>
	{
		if (getters.hasResults)
			watchedState.ui.isListVisible = true;
	};

	const clickOutside = (e) =>
	{
		if (!e.target.className.includes('search-lines-list'))
		{
			document.querySelector('.search-lines-list').outerHtml = '';
			window.removeEventListener('click', clickOutside);
		}
	};

	const click = (tag) =>
	{
		const event = new MouseEvent("click",
			{
				view: window,
				bubbles: true,
				cancelable: true,
			}
		);
		if (tag)
			tag.dispatchEvent(event);
	}

	const sleep = (time) =>
	{
		return new Promise((resolve) => setTimeout(resolve, Math.ceil(time)));
	}

	document.openCalcWith = async function(mark, model)
	{
		if (document.querySelectorAll('.modal-calc-wrapper-active').length === 0)
			click(document.querySelector('.header-bottom__btn'));

		let state = new StatesSaver();
		if (state.calc.getStep() > 3)
			click(document.querySelector('.modal-calc__bottom-btn-prev'));

		state.initState();
		state.calc.setCarMark(mark);
		state.calc.setCarModel(model);
		state.calc.setStep(3);
		await state.restoreState('calc');
	}

	const searchInputs = document.querySelectorAll('.search-input');
	searchInputs.forEach((input) =>
	{
		input.addEventListener('keyup', (e) =>
		{
			let url = apiEndpoints.searchLines + '?line=' + encodeURIComponent(e.target.value);
			axios.get(url)
			.then((result) =>
			{
				if (document.querySelector('.search-lines-list'))
					document.querySelector('.search-lines-list').remove();
				let list = '<ul class="search-lines-list">';
				result.data.forEach((i) =>
				{
					if (i.mark)
						list += '<li><span onclick="document.openCalcWith(\'' + i.mark + '\', \'' + i.model + '\')">' + i.name + '</span></li>';
					else
						list += '<li><a href="' + i.url + '">' + i.name + '</a></li>';
				});
				list += '</ul>';
				list = htmlToDom(list);
				e.target.parentNode.insertBefore(list, e.target.nextSibling);
			});
		});
	})

	document.addEventListener("click", (e) =>
	{
		let flyout = document.querySelector('.search-lines-list');
		if (!flyout)
			return;
		let target = e.target; // clicked element
		do
		{
			if(target === flyout)
				return;
			target = target.parentNode;
		}
		while (target);
		flyout.remove();
	});

	view.init({
		onInputHandle,
		handleInputFocus,
		handleBodyClick,
		handleBodyKeyUp,
		handleInputClick,
	});

	return view.element;
};
